import React from "react";
import "./ProgressBarCircular.css";

function ProgressBarCircular({
    value = 0,          // valeur courante (0 -> 100)
    size = 80,          // taille du cercle (px)
    strokeWidth = 6,    // épaisseur du trait
}) {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    const clampedValue = Math.round(Math.min(100, Math.max(0, value)));
    const offset = circumference - (clampedValue / 100) * circumference;
    
    return (
        <svg className="progress-circular" width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            {/* cercle de fond */}
            <circle
                className="progress-circular__track"
                cx={size / 2}
                cy={size / 2}
                r={radius}
                strokeWidth={strokeWidth}
            />

            {/* cercle de progression */}
            <circle
                className="progress-circular__value"
                cx={size / 2}
                cy={size / 2}
                r={radius}
                strokeWidth={strokeWidth}
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                transform={`rotate(-90 ${size / 2} ${size / 2})`}
            />

            {/* texte */}
            <text className="progress-circular__text" x="50%" y="50%">
                {clampedValue}%
            </text>
        </svg>
    );
}

export default ProgressBarCircular;